import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { alertActions, certboxActions } from '../../../../store/actions'
import { commons } from '../../../../hook/common'
import PwdPopup from './PwdPopup'
import history from '../../../../route/history'
import Alert from '../../../../module/alert/Alert'
import * as Common from '../../../../assets/js/common.js'

const CertboxReadingList = (props) => {

  const [certbox, setCertbox] = useState(new Set())
  const [fileObj, setFileObj] = useState(new Set())  
  const [certboxnew, setCertboxnew] = useState(new Set())
  const [certboxpwd, setCertboxpwd] = useState('')
  const [showPwdPopup, setShowPwdPopup] = useState(false)
  const [pwdConfirm, setPwdConfirm] = useState(false)
  const [active, setActive] = useState()

  useEffect(() => {
    if (props.isReading) {
      // 수신함 열람확인
      onPdfDown(fileObj)
    } else {
      return // 에러처리 전까진 그냥 리턴시킴
    }
  }, [props.isReading])

  useEffect(() => {
    if (pwdConfirm) {
      // 수신함 열람확인
      certbox.onetmPrslFileGroupReadInfoMap[fileObj.fileId] = 'Y'
      const params = {
        crtSeq: certbox.crtRcvSeq,
        onetmPrslFileGroupReadInfo : JSON.stringify(certbox.onetmPrslFileGroupReadInfoMap)
      }
      
      // props.readingbox(params)
      props.readingbox(params)
    } else {
      return // 에러처리 전까진 그냥 리턴시킴
    }
  }, [pwdConfirm])

  const onReading = (brno, fileObj, certbox) => {
    console.log(fileObj)
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    setCertboxpwd(brno)
    setCertboxnew(certbox)
    setCertbox(certbox)
    setFileObj(fileObj)
    setShowPwdPopup(true)
    //props.showPwdPopup(true, certbox)
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (fileObj) => {
    let fileList = []

    if (fileObj) {
      fileList.push(fileObj)
    }
    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        console.log(url)
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          /*
          let _anchor = document.createElement('a');
          _anchor.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
          _anchor.download = val['originFileNm']; // Set the file name.
          _anchor.style.display = 'none';
          document.body.appendChild(_anchor);
          _anchor.click();
          document.body.removeChild(_anchor);
          const file = new File([(xhr.response)], val['originFileNm'])
          window.open('/pdfViewer/pdfViewer.html?file=' + file, '_blank');
          */
          /*    if (Common.getDeviceType() === 'MobileApp' || Common.getDeviceType() === 'MobileWeb') {
            window.M.execute(
              'exWNStartViewElecDocActivity',
              process.env.REACT_APP_API_URL + '/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response),
            )
          } else { */
          window.open('/pdfViewer/pdfViewer.html?file=' + window.URL.createObjectURL(xhr.response), '_blank')
          //   }
        }
        
        // pdf 뷰어를 열게되면 새로고침 실행
        xhr.onloadend = ()=>{
          setTimeout(()=>{
          window.location.reload();
          },100000)
        }
        
      }, 20)
    })
  }

  const eventHandler = (e, docid) => {
    e.preventDefault()
    document.querySelectorAll(".attach-file").forEach((a)=>{
      if (a.id == docid){
        a.className='attach-file active'
      }else{
        a.className='attach-file'
      }
    })
  
  }
  const onShowOut = (e) => {
    e.preventDefault()
    setActive('')
  }

  return (
    <>
      <div className="tbl-wrap mt20" style={{ overflow: 'inherit' }}>
        <table className="tbl-list">
          <caption>문서명, 열람 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '80%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">문서명</th>
              <th scope="col">열람</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((certboxObj, index) => (
                <tr key={index}>
                  <td>
                    {certboxObj.crtNm} <span className="txt1">{certboxObj.docid}</span>
                  </td>
                  <td>
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <a
                            key={index}
                            href="#"
                            className="attach attach-link"
                            onClick={(e) => {
                              e.preventDefault()
                              onReading(certboxObj.brno, fileObj, certboxObj)
                              return
                            }}
                          >
                            첨부
                          </a>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        <a
                          href="#"
                          className="attach attach-link"
                          onClick={(e) => {eventHandler(e, certboxObj.docid + index)}}
                          aria-expanded={active === certboxObj.docid + index ? 'true' : 'false'}
                          aria-controls={certboxObj.docid + index}
                          // aria-disabled={active === certboxObj.docid + index ? 'true' : 'false'}
                        ></a>
                        <ul
                          id={certboxObj.docid + index}
                          // className={active === certboxObj.docid + index ?'attach-file active': 'attach-file'}
                          className='attach-file'
                          // style={{ zIndex: '9999' }}
                        >
                          {certboxObj.fileNewList?.map((fileObj, index) => (
                            certboxObj?.onetmPrslFileGroupReadInfoMap[fileObj.fileId] !='Y'&&(
                            <li key={index}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault()
                                  onReading(certboxObj.brno, fileObj, certboxObj)
                              	  onShowOut(e)
                                  return
                                }}
                              >
                                {fileObj.originFileNm}
                              </a>
                            </li>
                            )
                          ))}
                        </ul>
                      </div>
                    )}
                    {certboxObj.fileGroupId === null && '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={2}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showPwdPopup && (
        <PwdPopup
          certboxpwd={certboxpwd}
          certboxnew={certboxnew}
          onClose={() => setShowPwdPopup(false)}
          onNext={() => setPwdConfirm(true)}
        />
      )}
      {/* <Alert /> */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    isReading: state.certbox?.isReading,
    isShowPwdPopup: state.certbox.showPwdPopup,
  }
}

const actionCreators = {
  readcertboxReadingList: certboxActions.readcertboxReadingList,
  readingbox: certboxActions.readingbox,
  success: alertActions.success,
  confirm: alertActions.confirm,
  error: alertActions.error,
  showPwdPopup: certboxActions.showPwdPopup,
}

export default connect(mapStateToProps, actionCreators)(CertboxReadingList)
